export default __webpack_public_path__ + "static/media/certificateborder2.2ca730fb.png";